import { render, staticRenderFns } from "./IndividualLimits.vue?vue&type=template&id=efbf4e28&scoped=true&"
import script from "./IndividualLimits.vue?vue&type=script&setup=true&lang=ts&"
export * from "./IndividualLimits.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./IndividualLimits.vue?vue&type=style&index=0&id=efbf4e28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbf4e28",
  null
  
)

export default component.exports